import treasuryRst27Api from '../../api/treasury-rts27-api';
const TREASURY_RST27_SET_TECHNICAL_FAILURE = 'TREASURY_RST27_SET_TECHNICAL_FAILURE';
const TREASURY_RST27_SET_START_DATE = 'TREASURY_RST27_SET_START_DATE';
const TREASURY_RST27_SET_SECURITIES = 'TREASURY_RST27_SET_SECURITIES';

const treasuryRst27State = {
	technicalError: false,
	loading: true,
	startDate: null,
	securities: null
};

const treasuryRst27Actions = {
	init({ commit }, amount) {
		treasuryRst27Api.init(amount).then(
			(response) => {
				commit(TREASURY_RST27_SET_START_DATE, response.data.kezdoDatum);
				commit(TREASURY_RST27_SET_SECURITIES, response.data.ertekpapirok);
			},
			() => {
				commit(TREASURY_RST27_SET_TECHNICAL_FAILURE);
			}
		);
	},
	setTechnialError({ commit }) {
		commit(TREASURY_RST27_SET_TECHNICAL_FAILURE);
	}
};

const treasuryRst27Mutations = {
	[TREASURY_RST27_SET_TECHNICAL_FAILURE](state) {
		state.technicalError = true;
	},
	[TREASURY_RST27_SET_START_DATE](state, startDate) {
		state.startDate = startDate;
	},
	[TREASURY_RST27_SET_SECURITIES](state, securities) {
		state.securities = securities;
	}
};

export default {
	namespaced: true,
	state: treasuryRst27State,
	mutations: treasuryRst27Mutations,
	actions: treasuryRst27Actions
};
